import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import RichTextEditorField from 'components/forms/richTextEditor/RichTextEditorField';
import usePropertiesUpdatingAllowed from 'components/domain/property/usePropertiesUpdatingAllowed';
import {
  CollapseSectionStyled,
  DescriptionStyled,
} from './ServiceProvidersNotes.styles';

const ServiceProvidersNotes = () => {
  const { t } = useTranslation();
  const propertiesUpdatingAllowed = usePropertiesUpdatingAllowed();

  return (
    <CollapseSectionStyled
      data-testid="service-providers-notes"
      defaultExpanded
      label={t('pageProperty.serviceProviders.notes.title')}
      variant="card"
    >
      <Row>
        <Col sm={12}>
          <DescriptionStyled>
            {t('pageProperty.serviceProviders.notes.description')}
          </DescriptionStyled>
        </Col>

        <RichTextEditorField
          name="serviceProviders.notes"
          label={t('pageProperty.serviceProviders.notes.label')}
          colSmInput={8}
          colSmLabel={4}
          readOnly={!propertiesUpdatingAllowed}
        />
      </Row>
    </CollapseSectionStyled>
  );
};

export default ServiceProvidersNotes;
